import GenerateSuccessDialog from './generateSuccessDialog.component';

export default GenerateSuccessDialog;